import TransportIcon from "../../icon/service-icons/transport"
import SplitTextSection, { type SplitTextProps } from "../../section/splitText"

interface ExploreServiceProps extends SplitTextProps {
  borderColour?: string
  divWidth?: string
  items?: any[]
}

const ExploreServiceSection = ({ borderColour, divWidth, items, theme, ...props }: ExploreServiceProps) => {
  const includeAllServices = (items?.length && items.length > 4) ?? true

  const lightTheme = theme?.includes("light")
  const fontClass = `${lightTheme ? "" : "text-white"}`
  const iconColor = `${lightTheme ? "fill-purpleblue" : "fill-white"}`

  return (
    <div className={`${lightTheme ? "" : "border-b-4 border-white"}`}>
      <SplitTextSection
        bgColour="bg-gradient-blue1"
        theme={theme}
        pretitle="Explore more about our services"
        titleColour="text-orange"
        body={
          <>
            <p className={`mt-5 text-base md:text-lg xl:text-xl`}>
              We understand that one size doesn’t fit all when it comes to providing personalised support and solutions.
              Every individual and business has unique needs, challenges, and goals, and we pride ourselves on offering
              tailored services that reflect this diversity.
            </p>
          </>
        }
        customTextWidth={includeAllServices ? "md:max-w-[16.5rem]" : "md:w-1/2"}
        customDiv={
          <>
            {includeAllServices ? (
              <div
                className={`flex flex-col flex-wrap items-stretch justify-center gap-x-3 gap-y-4 md:flex-row ${divWidth ?? "w-full"}`}
              >
                {items?.map((Item, i) => (
                  <Item
                    key={i}
                    border
                    borderColour="border-green"
                    customSize="md:w-[calc(50%-6px)] xl:w-[calc(33%-6px)] h-[inhert]"
                    fontClass={fontClass}
                    iconColor={iconColor}
                  />
                ))}
              </div>
            ) : (
              <div className={`grid w-full gap-4 sm:grid-cols-2 ${divWidth ?? "xl:w-7/12"}`}>
                {items?.length && items.length % 2 === 0
                  ? items?.map((Item, i) => (
                      <div
                        key={i}
                        className={`rounded-xl border-[3px] ${i % 2 ? "border-orange" : "border-green"} sm:border-0`}
                      >
                        {
                          // border colour order different on mobile and desktop (design)
                          <Item
                            border="hideOnMobile"
                            borderColour={`${i === 1 || i === 2 ? "border-orange" : "border-green"}`}
                            // borderColour={`${i % 2 === 0? "border-orange" : "border-green"}`}
                            fontClass={fontClass}
                            iconColor={iconColor}
                          />
                        }
                      </div>
                    ))
                  : items?.map((Item, i) => (
                      <div
                        key={i}
                        className={`rounded-xl border-[3px] ${i % 2 ? "border-orange" : "border-green"} sm:border-0`}
                      >
                        {
                          <Item
                            border="hideOnMobile"
                            borderColour="border-green"
                            fontClass={fontClass}
                            iconColor={iconColor}
                          />
                        }
                      </div>
                    ))}
              </div>
            )}
          </>
        }
        gap="gap-8 xl:gap-10"
      />
    </div>
  )
}

export default ExploreServiceSection
